import Repository from '../Repository';

import { vue } from '../../main';

const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/dataimporter`;

export default {
  /**
   * Fetches a list of Channel Default Members and pushes them to the store.
   *
   * @returns {Promise<T | never>}
   */
  get() {
    return Repository.get(`${base}/get`);
  },
  set(script) {
    return Repository.post(`${base}/set`, {
      script,
    });
  },
  run() {
    return Repository.get(`${base}/run`);
  },
};
